import { render, staticRenderFns } from "./ButtonModalVoidTransaction.vue?vue&type=template&id=6d6e5a3a&scoped=true&"
import script from "./ButtonModalVoidTransaction.vue?vue&type=script&lang=js&"
export * from "./ButtonModalVoidTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonModalVoidTransaction.vue?vue&type=style&index=0&id=6d6e5a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e5a3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon,VTextarea})
